import { api } from './api';

export const organisationsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getOrganisations: build.query({
      query: (settings = {
        onlyWithUsers: false,
        onlyWithLocations: false,
      }) => ({
        url: "/users/organisations",
        method: "POST",
        body: JSON.stringify(settings),
      }),
      transformResponse: (response) => response.data,
      providesTags: (result) => {
        return result.data ?
          [ ...result.data.map(({ model}) => ({ type: 'Organisations', id: model.ID })),
            { type: 'Organisations', id: 'LIST' },
          ]
          :
          [{ type: 'Organisations', id: 'LIST' }]

      }
    }),
    getOrganisationsWithPagination: build.query({
      query: (
        query = {
          skip:0,
          limit: 40,
          filter: {text: ''},
        },
      ) => ({
        url: "organisations",
        method: "POST",
        body: JSON.stringify(query)
      }) ,
      providesTags: (result) => {
        return result.data ?
          [ ...result.data.records.map(({ model}) => ({ type: 'Organisations', id: model.ID })),
            { type: 'Organisations', id: 'LIST' },
          ]
          :
          [{ type: 'Organisations', id: 'LIST' }]

      }
    }),
  }),
});

export const {
  useGetOrganisationsQuery,
  useLazyGetOrganisationsQuery,
  useGetOrganisationsWithPaginationQuery,
} = organisationsApi;
